/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import DashboardIcon from '@material-ui/icons/Dashboard';
import GroupIcon from '@material-ui/icons/Group';
import HistoryIcon from '@material-ui/icons/History';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import SettingsIcon from '@material-ui/icons/Settings';
import HelpIcon from '@material-ui/icons/HelpOutline';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ArrowBack from '@material-ui/icons/ArrowBack';
import {
  AccountBox,
  Assessment,
  PersonAddDisabled
} from '@material-ui/icons';

export default [
  {
    subheader: '',
    items: [
      {
        title: 'Volver',
        href: '/auth/back-to-companies',
        icon: ArrowBack,
        isSuperAdminOnly: true
      }
    ]
  },
  {
    subheader: 'Informes',
    items: [
      {
        title: 'Resumen',
        href: '/overview',
        icon: DashboardIcon
      },
      {
        title: 'Historial',
        href: '/history',
        icon: HistoryIcon
      }
    ]
  },
  {
    subheader: 'Acciones',
    items: [
      {
        title: 'Company Status',
        href: '/company-status',
        icon: Assessment,
        isSuperAdminOnly: true
      },
      {
        title: 'Lista de administradores',
        href: '/list-admins-f',
        icon: AccountBox,
        isAdminFull: true
      },
      {
        title: 'Lista de empleados',
        href: '/list-employees',
        icon: GroupIcon
      },
      {
        title: 'Lista de exclusión',
        href: '/exclusion-list',
        icon: PersonAddDisabled
      },
      {
        title: 'Fichero empleados',
        href: '/import-csv',
        icon: VerticalAlignTopIcon
      },
      {
        title: 'Fichero liquidación',
        href: '/payroll',
        icon: VerticalAlignBottomIcon
      }
    ]
  },
  {
    subheader: 'Ajustes',
    items: [
      {
        title: 'Ajustes',
        href: '/settings/general',
        icon: SettingsIcon
      }
    ]
  },
  {
    subheader: '',
    items: [
      {
        title: 'Ayuda',
        href: '/help',
        icon: HelpIcon
      },
      {
        title: 'Cerrar sesion',
        href: '/auth/logout',
        icon: ExitToAppIcon
      }
    ]
  }
];
